(() => {
  if (window.shippingDateCheckoutInstalled) return;
  window.shippingDateCheckoutInstalled = true;
  let busy = false;
  const bypass = new WeakSet();
  const root = () => window.Shopify?.routes?.root || '/';
  const checkoutIds = ['checkout', 'CartDrawer-Checkout'];

  function today() {
    const parts = new Intl.DateTimeFormat('en-CA', { timeZone:'Asia/Tokyo', year:'numeric', month:'2-digit', day:'2-digit' }).formatToParts(new Date());
    const get = type => parts.find(part => part.type === type).value;
    return get('year') + '-' + get('month') + '-' + get('day');
  }
  function dateText(day, offset) {
    const date = new Date(day + 'T00:00:00Z');
    date.setUTCDate(date.getUTCDate() + offset);
    return (date.getUTCMonth() + 1) + '/' + date.getUTCDate() + '（' + ['日','月','火','水','木','金','土'][date.getUTCDay()] + '）';
  }
  function expected(item, day) {
    const absent = value => value === null || value === undefined || value === '';
    if (absent(item.min) && absent(item.max) && !item.properties?.['発送予定日']) return null;
    if (!/^\d+$/.test(String(item.min)) || !/^\d+$/.test(String(item.max))) throw new Error('発送日数が未設定の商品の設定をご確認ください');
    const min = Number(item.min), max = Number(item.max);
    if (!Number.isSafeInteger(min) || !Number.isSafeInteger(max) || min > max || max > 36500) throw new Error('発送日数の設定をご確認ください');
    return dateText(day,min) + '〜' + dateText(day,max);
  }
  async function json(url, options = {}) {
    const response = await fetch(url, { credentials:'same-origin', cache:'no-store', ...options });
    const result = await response.json();
    if (!response.ok || result.errors || result.status >= 400) throw new Error('発送予定日を保存できませんでした');
    return result;
  }
  async function snapshot() {
    const url = new URL(root() + 'cart', location.origin);
    url.searchParams.set('section_id','cart-shipping-data');
    url.searchParams.set('_shipping_refresh',String(Date.now()));
    const response = await fetch(url, { credentials:'same-origin', cache:'no-store' });
    if (!response.ok) throw new Error('発送日数を取得できませんでした');
    const document = new DOMParser().parseFromString(await response.text(),'text/html');
    const node = document.querySelector('[data-cart-shipping-data]');
    if (!node) throw new Error('発送予定日の更新ファイルを確認してください');
    const result = JSON.parse(node.textContent);
    if (!Array.isArray(result.items)) throw new Error('カート情報を確認できませんでした');
    result.items = result.items.map(item => ({ ...item, properties: Array.isArray(item.properties) ? Object.fromEntries(item.properties) : (item.properties || {}) }));
    return result;
  }
  function orderedProperties(properties, omitDate) {
    return Object.entries(properties || {}).filter(([key]) => !omitDate || key !== '発送予定日').sort(([a],[b]) => a.localeCompare(b));
  }
  function invariant(items) {
    const totals = new Map();
    for (const item of items) {
      const plan = item.selling_plan_id || item.selling_plan_allocation?.selling_plan?.id || null;
      const identity = JSON.stringify([item.variant_id,plan,orderedProperties(item.properties,true)]);
      totals.set(identity,(totals.get(identity)||0)+item.quantity);
    }
    return JSON.stringify([...totals].sort(([a],[b]) => a.localeCompare(b)));
  }
  function exact(items) {
    return JSON.stringify(items.map(item => [item.key,item.quantity,orderedProperties(item.properties,false)]).sort(([a],[b])=>a.localeCompare(b)));
  }
  async function refreshDates() {
    let baseline = null;
    let limit = 0;
    for (let pass = 0; ; pass++) {
      const day = today();
      const data = await snapshot();
      if (!data.items.length) throw new Error('カートが空です');
      if (baseline === null) { baseline = invariant(data.items); limit = data.items.length * 2 + 6; }
      if (pass > limit || invariant(data.items) !== baseline) throw new Error('カートが変更されました。確認してもう一度お試しください');
      const targets = data.items.map(item => ({ item, value:expected(item,day) }));
      const current = await json(root()+'cart.js');
      if (exact(current.items) !== exact(data.items)) throw new Error('カートが変更されました。もう一度お試しください');
      const target = targets.find(({ item,value }) => value !== null && item.properties?.['発送予定日'] !== value);
      if (!target) { if (today() !== day) continue; return current; }
      const result = await json(root()+'cart/change.js', {
        method:'POST', headers:{ 'Content-Type':'application/json' },
        body:JSON.stringify({ id:target.item.key, quantity:target.item.quantity, properties:{ ...target.item.properties, '発送予定日':target.value } })
      });
      if (invariant(result.items) !== baseline) throw new Error('カートの内容が変わりました。確認してもう一度お試しください');
    }
  }
  function status(button, text) {
    const container = button.closest('.cart__ctas');
    if (!container) return;
    let node = container.querySelector('[data-shipping-checkout-status]');
    if (!node) {
      node = document.createElement('p');
      node.dataset.shippingCheckoutStatus = '';
      node.setAttribute('role','status');
      node.style.cssText = 'font-size:12px;line-height:1.5;margin:8px 0;';
      container.appendChild(node);
    }
    node.textContent = text;
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    const button = event.submitter;
    if (!(form instanceof HTMLFormElement) || !button || !checkoutIds.includes(button.id)) return;
    if (bypass.has(form)) { bypass.delete(form); return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    const quantities = Array.from(document.querySelectorAll('cart-items input[name="updates[]"], cart-drawer-items input[name="updates[]"]'));
    if (document.querySelector('.cart__items--disabled, .product-form__submit.loading') || quantities.some(input => input.value !== input.getAttribute('value'))) {
      status(button,'数量などの更新が完了してから、もう一度押してください'); return;
    }
    busy = true;
    const controls = Array.from(document.querySelectorAll('cart-items input, cart-items button, cart-drawer-items input, cart-drawer-items button, cart-remove-button a, #checkout, #CartDrawer-Checkout'));
    const states = controls.map(control => ({ control, disabled:control.disabled, aria:control.getAttribute('aria-disabled') }));
    states.forEach(({control}) => { if ('disabled' in control) control.disabled = true; control.setAttribute('aria-disabled','true'); });
    const restore = () => states.forEach(({control,disabled,aria}) => {
      if ('disabled' in control) control.disabled = disabled;
      if (aria === null) control.removeAttribute('aria-disabled'); else control.setAttribute('aria-disabled',aria);
    });
    status(button,'発送予定日を更新しています');
    try {
      await refreshDates();
      restore();
      const updates = Array.from(form.elements).filter(input => input.name === 'updates[]');
      const updateStates = updates.map(input => [input,input.disabled]);
      updates.forEach(input => { input.disabled = true; });
      bypass.add(form);
      try { form.requestSubmit(button); }
      finally { updateStates.forEach(([input,disabled])=>{ input.disabled = disabled; }); }
      if (bypass.has(form)) { bypass.delete(form); throw new Error('購入手続きフォームを確認してください'); }
    } catch (error) {
      restore();
      status(button,(error.message || '更新に失敗しました') + '。購入手続きには進んでいません');
    } finally { busy = false; }
  }, true);
  document.addEventListener('click', event => {
    if (!busy) return;
    if (event.target.closest('cart-remove-button, cart-items, cart-drawer-items, .cart__dynamic-checkout-buttons')) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
})();
